
export function createAudioPlugin () {
  return function (store) {
    const playerStream = document.createElement('audio')
    const playerBroadcast = document.createElement('audio')

    playerStream.addEventListener('canplay', function () {
      if (!store.state.audio.stream.loaded) {
        store.dispatch('updateAudio', {
          stream: { loaded: true }
        })
      }
    })

    // broadcast duration
    playerBroadcast.addEventListener('durationchange', function () {
      store.dispatch('updateBroadcastMeta', { duration: playerBroadcast.duration })
    }, false)

    // broadcast progress
    playerBroadcast.addEventListener('timeupdate', function () {
      store.dispatch('updateBroadcastMeta', { position: playerBroadcast.currentTime })
    }, false)

    // broadcast end
    playerBroadcast.addEventListener('ended', function () {
      store.dispatch('closeBroadcast')
    }, false)

    // broadcast error
    playerBroadcast.addEventListener('ended', function () {
      store.dispatch('updateAudio', {
        broadcast: { paused: true, title: 'An error occured, sorry!', url: '', duration: 1, progress: 1 }
      })
    }, false)

    store.subscribe((mutation, state) => {
      if (mutation.type === 'setBroadcastSeek') {
        playerBroadcast.currentTime = state.audio.broadcast.position
      }

      if (mutation.type === 'setAudio') {
        // load stream
        if (playerStream.src !== state.audio.stream.url) {
          playerStream.src = state.audio.stream.url
        }

        // load a new broadcast
        if (playerBroadcast.src !== state.audio.broadcast.url) {
          playerBroadcast.src = state.audio.broadcast.url
        }

        // play/pause broadcast
        if (state.audio.broadcast.paused) playerBroadcast.pause()
        else playerBroadcast.play()

        // play/pause stream
        if (state.audio.stream.paused) {
          playerStream.pause()
        } else {
          playerStream.src = state.audio.stream.url
          playerStream.play()
        }
      }
    })
  }
}